import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useAnalytics } from '../contexts/AnalyticsContext';

const { FiMonitor, FiSmartphone, FiTablet } = FiIcons;

const DeviceBreakdown = () => {
  const { analyticsData } = useAnalytics();

  const getDeviceBreakdown = () => {
    const devices = {
      Desktop: 0,
      Mobile: 0,
      Tablet: 0
    };
    
    analyticsData.pageViews.forEach(pv => {
      const device = pv.device || 'Desktop';
      if (devices[device] !== undefined) {
        devices[device]++;
      } else {
        devices.Desktop++; // Default to desktop for unknown devices
      }
    });

    const total = Object.values(devices).reduce((sum, count) => sum + count, 0);
    
    return Object.entries(devices).map(([device, count]) => ({
      device,
      count,
      percentage: total > 0 ? (count / total) * 100 : 0
    }));
  };

  const deviceBreakdown = getDeviceBreakdown();

  const getDeviceIcon = (device) => {
    switch (device) {
      case 'Mobile': return FiSmartphone;
      case 'Tablet': return FiTablet;
      default: return FiMonitor;
    }
  };

  const getDeviceColor = (device) => {
    switch (device) {
      case 'Mobile': return 'text-green-600 bg-green-100';
      case 'Tablet': return 'text-purple-600 bg-purple-100';
      default: return 'text-blue-600 bg-blue-100';
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-6">Device Breakdown</h3>
      
      <div className="space-y-4">
        {deviceBreakdown.map((device, index) => (
          <motion.div
            key={device.device}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors"
          >
            <div className="flex items-center">
              <div className={`p-2 rounded-full mr-3 ${getDeviceColor(device.device)}`}>
                <SafeIcon 
                  icon={getDeviceIcon(device.device)} 
                  className="h-4 w-4" 
                />
              </div>
              <span className="text-sm font-medium text-gray-900">
                {device.device}
              </span>
            </div>
            <div className="text-right">
              <p className="text-sm font-semibold text-gray-900">
                {device.percentage.toFixed(1)}%
              </p>
              <p className="text-xs text-gray-500">
                {device.count} visits
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default DeviceBreakdown;